var _rect, _ellipse, _ellipse2, _ellipse3, _rect2, _ellipse4, _ellipse5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlbumElephant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "#ff4444"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 180,
    rx: 90,
    ry: 60,
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 170,
    rx: 20,
    ry: 30,
    fill: "#ff4444"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190,
    cy: 170,
    rx: 20,
    ry: 30,
    fill: "#ff4444"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 210,
    width: 20,
    height: 50,
    rx: 10,
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 120,
    rx: 40,
    ry: 30,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 120,
    rx: 15,
    ry: 10,
    fill: "#ff4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumElephant);
export default __webpack_public_path__ + "static/media/album-elephant.c6b6299a0388f75f85af2b1f077c768e.svg";
export { ForwardRef as ReactComponent };